
export const emailOnly = /^[a-zA-Z0-9._@.\-+]*$/g;
export const noSpacePresent = /^[S]+$/g;
export const usernamePattern = /^[A-z0-9_]{6,16}$/g;
export const mobilePhonePattern = /^\+[0-9]{9,16}$/g;
